import { useQuery } from '@tanstack/react-query'
import epsClient from 'enrollment-platform/api/eps.client'
import { RJSFSchema } from '@rjsf/utils'

export interface ConfigDefinition extends RJSFSchema {
  key: string
  xConfigType: 'configuration' | 'feature-flag'
  title: string
  description: string
  xCategory: string
}

export default function useConfigurationSchema(key: string | null) {
  return useQuery({
    queryKey: ['configurationSchema', key],
    queryFn: async (): Promise<ConfigDefinition> => {
      const response = await epsClient.get<ConfigDefinition>(
        `/admin/configs/definitions/${key}`
      )
      return response.data
    },
    enabled: key !== null && key.length > 0,
    staleTime: 5 * 60 * 1000,
  })
}
